import { render, staticRenderFns } from "./CustomColumn.vue?vue&type=template&id=022c255d&scoped=true"
import script from "./CustomColumn.vue?vue&type=script&lang=js"
export * from "./CustomColumn.vue?vue&type=script&lang=js"
import style0 from "./CustomColumn.vue?vue&type=style&index=0&id=022c255d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c255d",
  null
  
)

export default component.exports